import React from 'react';
import { motion } from 'framer-motion';
import PageContainer from '../components/layout/PageContainer';
import { auth } from "../firebaseConfig";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import GoogleImg from '../assets/GoogleImg.png';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { app } from "../firebaseConfig";
import LogoDizQueTem from '../assets/logo_Diz_que_tem-01.png';

interface SimpleUser {
  displayName: string | null;
  email: string | null;
  photoURL: string | null;
  uid: string;
}

function Login() {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  const loginGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const db = getFirestore(app);
      const userRef = doc(db, "users", result.user.uid);
      const userSnap = await getDoc(userRef);

      // Get the ID token
      const token = await result.user.getIdToken();
      localStorage.setItem('token', token);

      // Fetch user details from our backend
      const userDetailsResponse = await fetch('https://us-central1-appdizquetem.cloudfunctions.net/getUserDetails', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!userDetailsResponse.ok) {
        throw new Error('Failed to fetch user details');
      }

      const userDetails = await userDetailsResponse.json();
      console.log('User details from backend:', userDetails);

      if (userSnap.exists()) {
        const userData = userSnap.data();
        setUser({
          uid: result.user.uid,
          name: result.user.displayName || '',
          email: result.user.email || '',
          onboardingCompleted: userData.onboardingCompleted || false,
          accessLevel: userDetails.accessLevel,
          token
        });
        if (userData.onboardingCompleted) {
          navigate("/profile");
        } else {
          navigate("/onboarding");
        }
      } else {
        setUser({
          uid: result.user.uid,
          name: result.user.displayName || '',
          email: result.user.email || '',
          onboardingCompleted: false,
          accessLevel: userDetails.accessLevel,
          token
        });
        navigate("/onboarding");
      }
    } catch (error) {
      console.error("Erro ao logar:", error);
    }
  };

  return (
    <PageContainer>
      <div className="flex items-center justify-center min-h-[calc(100vh-64px)]">
        <div className="max-w-sm flex flex-col items-center space-y-6">
          {/* Profile Info */}
          <div className="text-center">
            <div className="w-32 h-32 rounded-full border-4 border-background bg-white/10 backdrop-blur-lg overflow-hidden mx-auto mb-4">
              <img
                src={LogoDizQueTem}
                alt="Logo Diz que tem"
                className="w-full h-full object-cover"
              />
            </div>
            <h1 className="text-2xl font-bold text-white mb-1">Entre com sua conta Google</h1>
          </div>

          {/* Login Button */}
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="flex items-center justify-center gap-3 bg-white border border-gray-300 text-gray-800 font-semibold py-3 px-8 rounded-full shadow transition hover:bg-gray-100"
            onClick={loginGoogle}
          >
            <img src={GoogleImg} alt="Google" className="w-6 h-6" />
            <span>Entrar com Google</span>
          </motion.button>
        </div>
      </div>
    </PageContainer>
  );
};

export default Login;
